import { createAction, props } from '@ngrx/store';
import { MappedHttpErrorResponse } from '@adnova/jf-ng-components';
import { AdminAnnouncementDTO, AnnouncementStatisticsDTO, PageableDTO, ProblemDTO } from '../../openapi/shell-service-openapi';

/**
 * Actions für Announcement-Entities.
 */
export class AnnouncementEntitiesActions {
  private static readonly prefix = '[Announcement Entities]';

  /** Lädt die Liste der Announcements. */
  static loadList = createAction(
    `${this.prefix} Load List`,
    props<{ pageable: PageableDTO }>(),
  );

  /** Liste erfolgreich geladen. */
  static loadListSuccess = createAction(
    `${this.prefix} Load List Success`,
    props<{ announcements: AdminAnnouncementDTO[]; totalElements: number }>(),
  );

  /** Fehler beim Laden der Liste. */
  static loadListFailure = createAction(
    `${this.prefix} Load List Failure`,
    props<{ error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Lädt die Statistiken. */
  static loadStatistics = createAction(
    `${this.prefix} Load Statistics`,
  );

  /** Statistiken erfolgreich geladen. */
  static loadStatisticsSuccess = createAction(
    `${this.prefix} Load Statistics Success`,
    props<{ statistics: AnnouncementStatisticsDTO }>(),
  );

  /** Fehler beim Laden der Statistiken. */
  static loadStatisticsFailure = createAction(
    `${this.prefix} Load Statistics Failure`,
    props<{ error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Löscht ein Announcement. */
  static delete = createAction(
    `${this.prefix} Delete`,
    props<{ id: string }>(),
  );

  /** Announcement erfolgreich gelöscht. */
  static deleteSuccess = createAction(
    `${this.prefix} Delete Success`,
    props<{ id: string }>(),
  );

  /** Fehler beim Löschen. */
  static deleteFailure = createAction(
    `${this.prefix} Delete Failure`,
    props<{ id: string; error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Veröffentlicht ein Announcement. */
  static publish = createAction(
    `${this.prefix} Publish`,
    props<{ id: string }>(),
  );

  /** Announcement erfolgreich veröffentlicht. */
  static publishSuccess = createAction(
    `${this.prefix} Publish Success`,
    props<{ id: string }>(),
  );

  /** Fehler beim Veröffentlichen. */
  static publishFailure = createAction(
    `${this.prefix} Publish Failure`,
    props<{ id: string; error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Zieht die Veröffentlichung eines Announcements zurück. */
  static unpublish = createAction(
    `${this.prefix} Unpublish`,
    props<{ id: string }>(),
  );

  /** Veröffentlichung erfolgreich zurückgezogen. */
  static unpublishSuccess = createAction(
    `${this.prefix} Unpublish Success`,
    props<{ id: string }>(),
  );

  /** Fehler beim Zurückziehen. */
  static unpublishFailure = createAction(
    `${this.prefix} Unpublish Failure`,
    props<{ id: string; error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );
}
